import { render } from "./ClientAddressCard.vue?vue&type=template&id=42e89280"
import script from "./ClientAddressCard.vue?vue&type=script&lang=js"
export * from "./ClientAddressCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__